import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: '12px',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  formContent: {
    padding: theme.spacing(2, 0),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  grupoEspelho: {
    padding: theme.spacing(2, 0),
  },
  dadoEspelho: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
  },
  valorEspelho: {
    fontSize: '13px',
    color: theme.palette.text.primary,
  },
  campoTitulo: {
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTypography-root': {
      fontWeight: 'bold',
      fontSize: '14px',
      color: theme.palette.text.primary,
    },
  },
  tipoVestigio: {
    width: '100%',
  },
  fieldGroup: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}))
